import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import {ContactsPage} from "../contacts/contacts";
import {ContactViewPage} from "../contact-view/contact-view";

@Component({
  selector: 'page-contact-new',
  templateUrl: 'contact-new.html'
})
export class ContactNewPage {
  // this tells the tabs component which Pages
  // should be each tab's root Page
  constructor(public navCtrl: NavController) {
  }
  goBack(params){
    if (!params) params = {};
    this.navCtrl.setRoot(ContactsPage);
    this.navCtrl.push(ContactViewPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/contact-new/contact-new.ts